import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { ClassToggleService, HeaderComponent } from '@coreui/angular-pro';
import { KeycloakService } from 'keycloak-angular';
import { UsuarioResponse } from 'app/domain/models/alpura/usuario';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
})
export class DefaultHeaderComponent extends HeaderComponent implements OnInit {
  usuarioResponse: UsuarioResponse = {
    email: '',
    nombre: '',
  };

  permisos: any;
  usuarioParse: any;
  usuario: any;
  @Input() sidebarId: string = 'sidebar1';

  public newMessages = new Array(4);
  public newTasks = new Array(5);
  public newNotifications = new Array(5);

  public themeSwitch = new UntypedFormGroup({
    themeSwitchRadio: new UntypedFormControl('light'),
  });

  constructor(
    private classToggler: ClassToggleService,
    private readonly keycloak: KeycloakService
  ) {
    super();
  }

  ngOnInit(): void {
    let perfil = localStorage.getItem('usuario');
    if (perfil != null) {
      let perfilParse = JSON.parse(perfil);
      this.usuarioResponse = {
        email: perfilParse.email,
        nombre: perfilParse.nombre,
      };
    } else {
    }
  }

  setTheme(value: string): void {
    this.themeSwitch.setValue({ themeSwitchRadio: value });
    this.classToggler.toggle('body', 'dark-theme');
  }

  cerrarSesion() {
    localStorage.clear();
    this.keycloak.logout();
  }
}
